import { ProductFiltersFieldId } from '@epicuro-next/models/product-filters';
import { Filter } from 'graphql-api/gql-api-interfaces';

export const isDateFilter = (filter: Filter) =>
  filter.fieldId.toLowerCase().includes(ProductFiltersFieldId.Availability);
